//cspell:disable
import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Foter from './Foter';
import Useletter from './Useletter';

function BG() {
  return (
    <div>
        <Container>
      <Row>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/kg_1.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px',
             borderRadius:'100%'

        }}/>
        </Col>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/KB_2.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px',
             borderRadius:'100%'

        }}/>
        </Col>
      </Row>
      </Container>


      <p>MEN'S TRADITIONAL <hr /></p>



<Container>
  <Row>
    <Col xs={12} sm={6} md={4} lg={3} >
    <div className="box-content">
    <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/3/5/35840_3.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
       alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> 
<br></br>
<button className='bag'> ADD TO BAG</button>
</div>

    </Col>
    <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/3/4/34844.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> <br></br>
<button className='bag'> ADD TO BAG</button>
</div></Col>
    <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/3/4/34922.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>YELLOW CAMBRIC PRINTED 

<br />
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> <br></br>
<button className='bag'> ADD TO BAG</button>
</div></Col>
    <Col xs={12} sm={6} md={4} lg={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/3/4/34920.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=300&width=240&canvas=240:300&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED  <br />
<b>PKR 2,590.00</b>
</p>
</div>
<div className="d">
<div id="d1">XS</div>
<div id="d1">S</div> 
<div id="d1">M</div>
<div id="d1">L</div>
 <div id="d1">XL</div>
</div> <br></br>
<button className='bag'> ADD TO BAG</button>
</div></Col>
    
  </Row>
</Container>
<Container>
      <Row>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/tb.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px',
             borderRadius:'100%'

        }}/>
        </Col>
        <Col xs={12} md={6}>
        <img
        src='https://www.junaidjamshed.com/media/wysiwyg/tg.jpg'
        alt=''
        style={{
            width:'100%',
            height:'auto',
            objectFit:'cover',
             marginTop: '90px',
             borderRadius:'100%'

        }}/>




        </Col>
      </Row>
      </Container>
<Useletter/>
      <Foter/>

    </div>
  )
}

export default BG
